if (!window.cartPage99Initialized) {
  window.cartPage99Initialized = true;

  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  };

  const escapeHtml = (str) => {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  };

  const getPageWidthEl = () => document.querySelector('.cart-page-99__header')?.closest('.page-width');

  const showError = (message) => {
    const errorsEl = document.getElementById('CartPage99-Errors');
    if (!message || !errorsEl) return;
    errorsEl.textContent = message;
    errorsEl.hidden = false;
  };

  const clearError = () => {
    const errorsEl = document.getElementById('CartPage99-Errors');
    if (!errorsEl) return;
    errorsEl.hidden = true;
    errorsEl.textContent = '';
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-flyout-99-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };

  const getColorAndSize = (item) => {
    let color = null;
    let size = null;
    (item.options_with_values || []).forEach((option) => {
      const name = option.name.toLowerCase();
      if (name.includes('colou') || name.includes('color')) color = option.value;
      else if (name.includes('size')) size = option.value;
    });
    return { color, size };
  };

  const itemTemplate = (item) => {
    const { color, size } = getColorAndSize(item);
    const colorHtml = color ? `<div class="cart-page-99__item-color">[${escapeHtml(color)}]</div>` : '';
    const sizeHtml = size ? `<div class="cart-page-99__item-size">${escapeHtml(size)}</div>` : '';

    const image = item.image
      ? `<img class="cart-page-99__item-image" src="${item.image.replace(/(\.[a-z]+)(\?|$)/, '_300x$1$2')}" alt="${escapeHtml(item.product_title)}" loading="lazy">`
      : '<div class="cart-page-99__item-image cart-page-99__item-image--placeholder"></div>';

    return `
      <div class="cart-page-99__item" data-key="${item.key}">
        <a href="${item.url}" class="cart-page-99__item-image-link" tabindex="-1" aria-hidden="true">
          ${image}
        </a>
        <div class="cart-page-99__item-details">
          <a href="${item.url}" class="cart-page-99__item-title">${escapeHtml(item.product_title)}</a>
          ${colorHtml}
          ${sizeHtml}
        </div>
        <div class="cart-page-99__item-qty">
          <button type="button" data-qty-minus aria-label="Decrease quantity">&minus;</button>
          <input type="number" min="0" value="${item.quantity}" data-qty-input aria-label="Quantity">
          <button type="button" data-qty-plus aria-label="Increase quantity">&plus;</button>
        </div>
        <div class="cart-page-99__item-price" data-item-price>
          ${formatMoney(item.final_line_price)}
        </div>
      </div>
    `;
  };

  const renderFullCart = (cart) => {
    const pageWidthEl = getPageWidthEl();
    if (!pageWidthEl) return;

    const headerEl = document.querySelector('.cart-page-99__header');
    const footerEl = document.getElementById('CartPage99-Footer');
    const subtotalEl = document.getElementById('CartPage99-Subtotal');
    const checkoutBtn = document.getElementById('CartPage99-Checkout');

    console.log(headerEl)

    updateCartCount(cart.item_count);

    if (cart.item_count === 0) {
        pageWidthEl.querySelector('#CartPage99-Items')?.remove();
        pageWidthEl.querySelector('#CartPage99-Errors')?.remove();

        if (!pageWidthEl.querySelector('.cart-page-99__empty')) {
        pageWidthEl.insertAdjacentHTML('beforeend', `
            <div class="cart-page-99__empty">
            <h2 class="cart-page-99__empty-text">${window.cartStrings && window.cartStrings.empty ? window.cartStrings.empty : 'Your cart is empty'}</h2>
            <a href="/collections/shop" class="button">Continue shopping</a>
            </div>
        `);
        }

        if (headerEl) headerEl.classList.add('is-empty');
        if (footerEl) footerEl.classList.add('is-empty');
        if (checkoutBtn) checkoutBtn.setAttribute('disabled', 'disabled');
        return;
    }

    pageWidthEl.querySelector('.cart-page-99__empty')?.remove();

    let itemsEl = document.getElementById('CartPage99-Items');
    if (!itemsEl) {
        pageWidthEl.insertAdjacentHTML('beforeend', `
        <div id="CartPage99-Items" class="cart-page-99__items"></div>
        <div id="CartPage99-Errors" class="cart-page-99__errors" role="alert" hidden></div>
        `);
        itemsEl = document.getElementById('CartPage99-Items');
    }

    itemsEl.innerHTML = cart.items.map((item) => itemTemplate(item)).join('');

    if (headerEl) headerEl.classList.remove('is-empty');
    if (footerEl) footerEl.classList.remove('is-empty');
    if (checkoutBtn) checkoutBtn.removeAttribute('disabled');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    bindPageEvents();
    };

  const updateLine = (key, quantity) => {
    if (!key) return;

    const itemsEl = document.getElementById('CartPage99-Items');
    const row = itemsEl ? itemsEl.querySelector(`[data-key="${key}"]`) : null;
    clearError();

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: parseInt(quantity, 10) || 0 }),
    })
      .then((res) => res.json())
      .then((cart) => {
        if (cart.status) {
          showError(cart.description || cart.message);
          return;
        }

        const updatedItem = cart.items.find((item) => item.key === key);
        const requestedQty = parseInt(quantity, 10) || 0;
        if (updatedItem && updatedItem.quantity < requestedQty) {
          showError(
            window.cartStrings && window.cartStrings.quantityError
              ? window.cartStrings.quantityError.replace('[quantity]', updatedItem.quantity)
              : `Only ${updatedItem.quantity} available — your cart has been updated.`
          );
        }

        document.dispatchEvent(new CustomEvent('cart:99:updated', { detail: cart, bubbles: false }));
        renderFullCart(cart);
      })
      .catch(() => {
        showError(window.cartStrings ? window.cartStrings.error : 'Something went wrong.');
      });
  };

  const updateDebounced = debounce(updateLine, 350);

  function bindPageEvents() {
    const itemsEl = document.getElementById('CartPage99-Items');
    if (!itemsEl || itemsEl.dataset.bound) return;
    itemsEl.dataset.bound = 'true';

    itemsEl.addEventListener('click', (e) => {
      const minus = e.target.closest('[data-qty-minus]');
      const plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;

      const row = e.target.closest('.cart-page-99__item');
      const input = row.querySelector('[data-qty-input]');
      let val = parseInt(input.value, 10) || 0;
      val = minus ? Math.max(0, val - 1) : val + 1;
      input.value = val;
      updateDebounced(row.dataset.key, val);
    });

    itemsEl.addEventListener('change', (e) => {
      const input = e.target.closest('[data-qty-input]');
      if (!input) return;
      const row = e.target.closest('.cart-page-99__item');
      const val = Math.max(0, parseInt(input.value, 10) || 0);
      updateDebounced(row.dataset.key, val);
    });
  }

  document.addEventListener('cart:99:updated', (e) => {
    if (!getPageWidthEl()) return;
    renderFullCart(e.detail);
  });

  bindPageEvents();
}